<template>
  <div class="back-to-main" @click="navigateToHome">
    <svg width="27" height="15" viewBox="0 0 27 15" fill="none">
      <rect
        width="1.98052"
        height="24.6213"
        transform="matrix(-0.00338485 0.999994 -0.999995 -0.00331923 26.4004 6.15967)"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.1844 7.02761L8.8985 1.57421L7.5425 0.137733L0.399348 6.95498L1.75535 8.39145L1.75577 8.39106L7.1801 14.1373L8.60873 12.7738L3.1844 7.02761Z"
        fill="white"
      />
    </svg>
    <h6 class="white">{{backInfo.name}}</h6>
  </div>
</template>
<script>
export default {
  props: {
    backInfo: {
      type: Object,
    },
  },
  methods: {
    navigateToHome() {
      this.$router.push(this.backInfo.path);
    },
  },
};
</script>
<style lang="scss" scoped>
.back-to-main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 2.5rem 0.5rem 2.5rem 0;
  min-width: 20rem;
  width: 20rem;
  position: absolute;
  bottom: 8.5rem;
  top: inherit;
  left: 0;
  margin: 0;
  padding: 0;
  height: 2rem;
  cursor: pointer;
  transition: all 1.2s ease-in-out;
  z-index: 2;
  @media only screen and (max-width: 992px) {
    min-width: 10rem;
    width: 15rem;
    padding: 2rem 1.5rem 2rem 0;
  }
  @media only screen and (max-width: 768px) {
    width: 20rem;
    position: relative;
    bottom: inherit;
    margin-bottom: 3rem;
  }
  svg {
    display: block;
    width: 2.6rem;
    min-width: 2.6rem;
    height: 1.4rem;
    margin-right: 0.8rem;
  }
}
.template-page .intro .content > div {
  &.no-anima-block {
    transform: translate(0, 0);
    opacity: 1;
    &.above-viewport {
      & + .back-to-main {
        position: fixed;
        top: 10rem;
        bottom: inherit;
        rect,
        path {
          fill: #333536;
        }
        h6.white {
          color: #333536;
        }
      }
    }
  }
}
</style>